import { useEffect, useState } from 'react';
import ProductService from 'services/product';
import { toSearchText } from 'utils/text';

const service = new ProductService();

const useProductPicker = (props) => {
  const { value = [], onChange, mode = 'multiple', placeholder = 'Chọn sản phẩm', ...selectProps } = props;
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        let list = await service.list({});
        list = Array.isArray(list) ? list : [];
        setOptions(list.map((item) => ({
          label: item.name,
          value: item.id,
          searchText: toSearchText(item.name || ''),
        })));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return {
    value,
    onChange,
    mode,
    placeholder,
    selectProps,
    options,
    loading,
  };
};

export default useProductPicker;